import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-43">
          <div data-id="element-44">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3vYWku74T56xRpPWZ2cNd9/lama_icon_logo_weiss.png" alt="Legallama Logo" className="h-10 w-auto mb-4" data-id="element-45" />
            <p className="text-gray-400 max-w-md" data-id="element-46">
              Legallama – Automatisierung für Fachanwälte im Verkehrsrecht
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-8" data-id="element-47">
            <div data-id="element-48">
              <h4 className="font-semibold mb-4" data-id="element-49">Rechtliches</h4>
              <ul className="space-y-2 text-gray-400" data-id="element-50">
                <li data-id="element-51">
                  <a href="https://pezula.ai/imprint/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-52">
                    Impressum
                  </a>
                </li>
                <li data-id="element-53">
                  <a href="https://pezula.ai/data-privacy/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-54">
                    Datenschutz
                  </a>
                </li>
                <li data-id="element-55">
                  
                </li>
              </ul>
            </div>
            <div data-id="element-56">
              <h4 className="font-semibold mb-4" data-id="element-57">Kontakt</h4>
              <ul className="space-y-2 text-gray-400" data-id="element-58">
                <li data-id="element-59">
                  <a href="mailto:hello@legallama.de" className="hover:text-white transition-colors" data-id="element-60">
                    Kontakt
                  </a>
                </li>
                <li data-id="element-61">
                  <a href="mailto:hello@legallama.de?subject=Ich%20w%C3%BCnsche%20eine%20Demo%20zu%20Legallama!" className="hover:text-white transition-colors" data-id="element-62">
                    Demo buchen
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400" data-id="element-63">
          <p data-id="element-64">&copy; 2024 Legallama. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>;
}